import ApiClient from '../ApiClient';

class AidexacxBulkActionsAPI extends ApiClient {
  constructor() {
    super('aidexacx/bulk_actions', { accountScoped: true });
  }
}

export default new AidexacxBulkActionsAPI();
